// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Qyb3","content":"LayoutSettings_content__2npnP"};